import { useMemo } from 'preact/hooks'
import { Location } from '../../models/location'

export const useLocationTimezone = (location?: Location) => {
    const timeZoneData = useMemo(() => {
        const timeZone = location?.timezone ?? 'America/New_York'
        const shortTimezone = new Date().toLocaleTimeString('en-us', { timeZone, timeZoneName: 'short' }).split(' ')[2]

        return {
            timeZone,
            shortTimezone,
        }
    }, [])

    return timeZoneData
}
